import { useState } from "react";
import { X } from "lucide-react";
import Reveal from "@/components/common/Reveal";
import { GALLERY_IMAGES } from "@/data/content";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <>
      <section className="pt-20 md:pt-24 pb-6 md:pb-10 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14" data-testid="gallery-hero">
        <div className="mono-label text-zinc-500">Gallery</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] font-light mt-3 max-w-4xl">
          From <em className="not-italic text-[#BE1E2D] font-normal">site</em> to handover.
        </h1>
        <p className="text-zinc-600 text-base md:text-lg max-w-xl mt-6 leading-relaxed">
          A visual archive of construction progress, delivered projects and the people who make them real.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 pb-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
          {GALLERY_IMAGES.map((src, i) => {
            const tall = i % 5 === 0 || i % 5 === 3;
            return (
              <Reveal key={i} delay={(i % 4) * 0.05}>
                <button
                  onClick={() => setActive(src)}
                  className={`img-hover-scale w-full bg-zinc-100 block ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`}
                  data-testid={`gallery-image-${i}`}
                  aria-label={`Open image ${i + 1}`}
                >
                  <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
                </button>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* LIGHTBOX */}
      {active && (
        <div
          className="fixed inset-0 z-[70] bg-black/95 flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-white hover:text-[#BE1E2D] transition-colors"
            aria-label="Close"
            data-testid="gallery-lightbox-close"
          >
            <X className="w-8 h-8" />
          </button>
          <img src={active} alt="" className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </>
  );
}
